module.exports = __webpack_public_path__ + "static/media/iconInProcess.53ffa46b.svg";